import Link from "next/link"
import MenuIcon from "components/MenuIcon"

export default function MobileSubMenu({submenus, isDropdownOpen, onClose}) {
    const style = {
        height: isDropdownOpen ? submenus.length * 45 * 2 : "0",
    };

    return (
        <ul className={`sub-menu ${isDropdownOpen ? "show" : ""}`} style={style}>
            {submenus.map((submenu, index) => {
                const path = !submenu.path.startsWith("/") ? "/" + submenu.path : submenu.path
                return (
                    <li key={`${path}_${index}`}>
                        <div className="d-flex flex-row">
                            <MenuIcon color="white" size="24" className="m-3" iconName={submenu.icon}/>
                            <Link href={submenu.path} className="p-1" onClick={onClose}>
                                <div className="d-flex flex-column pt-2">
                                    <h6 className="text-light-emphasis mb-1">{submenu.title}</h6>
                                    <p className="figure-caption">{submenu.subTitle}</p>
                                </div>
                            </Link>
                        </div>
                    </li>
                )
            })}
        </ul>
    )
        ;
}
